var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "stroke",
    d: "M1 8.2V1M1 1H8.2M1 1L9 9",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-path": "stroke",
    d: "M1 12V12C1 13.8692 1 14.8038 1.40192 15.5C1.66523 15.9561 2.04394 16.3348 2.5 16.5981C3.19615 17 4.13077 17 6 17H11C13.8284 17 15.2426 17 16.1213 16.1213C17 15.2426 17 13.8284 17 11V6C17 4.13077 17 3.19615 16.5981 2.5C16.3348 2.04394 15.9561 1.66523 15.5 1.40192C14.8038 1 13.8692 1 12 1V1",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIn);
export default __webpack_public_path__ + "static/media/open-in.5eab521a81426c5d5157b64130e80164.svg";
export { ForwardRef as ReactComponent };